<template>
  <div class="agenSort-list-main-page">
    <main-header :hasBanner="true" :type="'resourcesList'"></main-header>
    <section class="main-center list-clr">
      <list-left :type="'resourcesList'"></list-left>
      <div class="page-right">
        <div class="right-top">
          <div class="right-title">挂牌房源公示</div>
          <!-- <div class="post-release" @click="goRelease">发布房源</div> -->
        </div>
        <el-table stripe :data="tableData" border style="width: 100%">
          <el-table-column
            align="centet"
            header-align="center"
            prop="code"
            label="房源核验统一编码"
          >
          </el-table-column>
          <el-table-column
            align="centet"
            header-align="center"
            prop="districtName"
            label="所属城区"
          ></el-table-column>

          <el-table-column
            align="centet"
            header-align="center"
            prop="communityName"
            label="小区"
          >
          </el-table-column>
          <el-table-column
            align="centet"
            header-align="center"
            prop="architarea"
            label="面积"
          >
          </el-table-column>
          <el-table-column
            align="centet"
            header-align="center"
            prop="houseprice"
            label="委托价格"
          >
          </el-table-column>
          <el-table-column
            align="centet"
            header-align="center"
            prop="companyName"
            label="挂牌机构"
          >
          </el-table-column>
          <el-table-column
            align="centet"
            header-align="center"
            prop="startDate"
            label="挂牌时间"
          >
          </el-table-column>

          <el-table-column
            align="centet"
            header-align="center"
            label="详细"
            width="80"
          >
            <template slot-scope="scope">
              <img
                @click="goDetail(scope.row)"
                style="width: 20px; cursor: pointer"
                src="@/assets/img/search.png"
                alt=""
              />
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          class="bottom-pagination"
          background
          @current-change="handleCurrentChange"
          :current-page="pagingObj.pageNum"
          :page-size="pagingObj.pageSize"
          layout="prev, pager, next, jumper, total "
          :total="total"
        >
        </el-pagination>
      </div>
    </section>
    <main-footer></main-footer>
  </div>
</template>

<script>
import mainHeader from "@/components/mainHeader";
import mainFooter from "@/components/mainFooter";
import listLeft from "@/components/listLeft";
import { resourcesList } from "@/assets/api/resources";
import { districtList } from "@/assets/api/common";

export default {
  name: "creditList",
  components: {
    mainHeader,
    mainFooter,
    listLeft,
  },
  data() {
    return {
      tableData: [],
      pagingObj: {
        pageNum: 1,
        pageSize: 10,
        districtId: "",
        name: "",
      },
      total: 0,
      options: [],
    };
  },
  computed: {},
  mounted() {
    this.getData();
    this.initCity();
  },
  methods: {
    goRelease() {
     this.$router.push({
        path: "/resources/release", //跳转的路径
      });
    },
    async initCity() {
      const res = await districtList();
      this.options = ((res && res.data && res.data.data) || []).map((item) => {
        return {
          value: item.id,
          label: item.name,
        };
      });
      this.options.unshift({
        value: null,
        label: "全部",
      });
    },
    goDetail(item) {
      const jumpUrl = this.$router.resolve({
        path: "/resources/detail",
        query: { id: item.id },
      });
      window.open(jumpUrl.href, "_blank");
    },
    showCode(i) {
      this.$set(this.tableData[i], "showCode", true);
    },
    hideCode(i) {
      this.$set(this.tableData[i], "showCode", false);
    },
    handleCurrentChange(val) {
      this.pagingObj.pageNum = val;
      this.getData();
    },
    async getData() {
      const res = await resourcesList(this.pagingObj);
      if (res && res.data && res.data.code == 200) {
        this.tableData = res.data.rows || [];
        this.total = res.data.total;
      }
    },
    search() {
      this.pagingObj.pageNum = 1;
      this.getData();
    },
  },
};
</script>

<style lang="less">
.agenSort-list-main-page {
  background: #fff;
  .list-clr {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;

    .page-right {
      flex: 1;
      .right-top {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        justify-content: space-between;
        .right-title {
          font-size: 18px;
          color: #222;
        }
        .right-tips {
          margin-top: 20px;
          color: #b1191a;
          font-size: 14px;
        }
        .post-release {
          color: #fff;
          background-color: #b1191a;
          font-size: 18px;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 120px;
          height: 48px;
          cursor: pointer;
        }
        .ad-select {
          width: 203px;
          input {
            height: 50px;
            border-radius: 0;
          }
        }
        .ad-input {
          width: 520px;
          height: 50px;
          border: 1px solid #dcdfe6;
          border-left: 0;
          border-right: 0;
          input {
            height: 100%;
            border: none;
          }
        }
        .search-btn {
          background: #9b2f3d;
          width: 140px;
          height: 50px;
          line-height: 50px;
          text-align: center;
          color: #fff;
          font-weight: bold;
          font-size: 16px;
          border-top-right-radius: 5px;
          border-bottom-right-radius: 5px;
          cursor: pointer;
        }
      }
    }
  }
  .mg-t20 {
    margin-top: 20px;
  }

  .el-table .cell {
    overflow: initial !important;
  }
  .el-table {
    overflow: initial !important;
  }
  .el-table__body-wrapper {
    overflow: initial !important;
  }
  .qr-box {
    position: relative;
    z-index: 2;
    img {
      position: absolute;
      z-index: 1;
      left: -50px;
      top: 10px;
    }
  }
  .bottom-pagination {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-left: 0;
    padding-right: 0;
  }
}
</style>